import axios from 'axios'

export default {
    create(data) {
        const payload = {
            razon_social: data.razonSocial,
            nombre_fantasia: data.nombreFantasia,
            cuit: data.cuit,
            email: data.email,
            direccion: data.direccion,
            localidad_id: data.localidad && data.localidad.id ? data.localidad.id : null,
            dueno_nombre: data.duenNombre,
            dueno_apellido: data.duenApellido,
            dueno_email: data.duenEmail,
            dueno_password: data.duenPassword,
        }
        if (data.condicionIvaId) payload.condicion_iva_id = data.condicionIvaId
        if (data.fechaInicioActividades) payload.fecha_inicio_actividades = data.fechaInicioActividades
        if (data.planCodigo) payload.plan_codigo = data.planCodigo
        return axios.post('/empresas/alta', payload)
    },
    index(is_active) {
        return axios.get(`/empresas?is_active=${is_active}`)
    },
    show(uuid) {
        return axios.get(`/empresas/${uuid}`)
    },
    update(uuid, data) {
        return axios.put(`/empresas/${uuid}`, data)
    },
    condicionesIva() {
        return axios.get('/empresas/condiciones-iva')
    },
    // confirmar: el nombre del proveedor escrito a mano; sin él el back no borra
    eliminarProductosProveedor(proveedorId, confirmar) {
        return axios.delete(`/productos/plantilla/${proveedorId}/eliminar-productos`, { params: { confirmar } })
    },
}